import React from "react";
import styled, { keyframes } from "styled-components";

const Buffer = () => {
  return (
    <LoaderWrapper>
      <Spinner>
        {Array.from({ length: 8 }).map((_, i) => (
          <Bar key={i} $index={i} />
        ))}
      </Spinner>
    </LoaderWrapper>
  );
};

export default Buffer;

// ===== Styled Components =====
const LoaderWrapper = styled.div`
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const Spinner = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  margin: 0 auto;
`;

const spin = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0.2; }
`;

const Bar = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3px;
  height: 9px;
  background: #000;
  border-radius: 3px;
  transform-origin: center -10px;
  transform: rotate(${(props) => props.$index * 45}deg);
  animation: ${spin} 1s linear infinite;
  animation-delay: ${(props) => props.$index * 0.12}s;
`;
